<!-- 文件管理的页面-->
<template>
  <div class="file-index-page">
    <el-container class="file-whole">
      <el-main class="file-list">
        <h2 style="display: flex;justify-content: space-between;align-items: center;">
          文件列表
          <div>
            <el-date-picker
              v-model="timeOption"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="-"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :picker-options="fileTimeOptions"
              style="width: 250px;margin-right: 20px"
            ></el-date-picker>
            <el-input
              style="width: 250px;margin-right: 20px"
              clearable
              placeholder="请输入文件名关键词"
              prefix-icon="el-icon-search"
              v-model="searchVal">
            </el-input>
          </div>
        </h2>
        <waiting v-if="isLoading"></waiting>
        <div class="batch-button">
          <el-button type="primary" plain size="small" round v-show="showBatchDownload" @click="batchDownload">批量下载
          </el-button>
          <el-button type="success" size="small" round plain v-show="showBatchUpload" @click="batchUpload">批量上传
          </el-button>
          <el-button type="warning" size="small" round plain v-show="showBatchBlf" @click="batchConvertBLF">批量转blf
          </el-button>
          <el-button type="danger" size="small" round plain v-show="showBatchDelete" @click="batchDelete">批量删除
          </el-button>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="curFileListLength"
          style="float:right;margin: 20px 0">
        </el-pagination>
        <el-table
          :data="curFileList"
          ref="fileTable"
          class="file-list-table"
          :default-sort="{ prop: 'creTime', order: 'descending' }"
          @sort-change="sortChange"
          @filter-change="filterChange"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="name"
            label="文件名"
            sortable="custom"
            fixed
            min-width="130px"
            :filters="[
              { text: 's19', value: 'type_s19' },
              { text: 'dat', value: 'type_dat' },
              { text: 'mdf', value: 'type_mdf' },
              { text: 'asc', value: 'type_asc' },
              { text: 'blf', value: 'type_blf' },
              { text: '其他', value: 'type_others' },
            ]"
          >
          </el-table-column>
          <el-table-column
            prop="creTime"
            label="创建日期"
            sortable="custom"
            width="160px"
          ></el-table-column>
          <el-table-column
            prop="length"
            label="文件大小"
            sortable="custom"
            min-width="100px"
          >
          </el-table-column>
          <el-table-column
            prop="deviceVo.deviceName"
            label="设备名"
            min-width="150px"
            :filters="allDeviceList"
          ></el-table-column>
          <el-table-column
            prop="deviceVo.online"
            label="设备状态"
            min-width="100px"
            :filters="[
              { text: '在线', value: 'online' },
              { text: '离线', value: 'offline' }
            ]"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.deviceVo.online">
                在线
              </span>
              <span v-else>
                离线
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fileStatus"
            label="文件状态"
            min-width="100px"
            :filters="[
              { text: '在内存卡中', value: 'ONSD' },
              { text: '在U盘中', value: 'ONUDISK' },
              { text: '在服务器上', value: 'ONSERVER' }
            ]"
            column-key="status"
          >
            <template slot-scope="scope">
              <span v-show="scope.row.deviceFileStatus === 'ONSD'">
                在内存卡中
              </span>
              <span v-show="scope.row.deviceFileStatus === 'ONUDISK'">
                在U盘中
              </span>
              <span v-show="scope.row.deviceFileStatus === 'ONSERVER'">
                在服务器上
              </span>
            </template>
          </el-table-column>
          <el-table-column label='操 作' width="200">
            <template slot-scope="scope">
              <el-button
                class="buttons"
                v-if="(scope.row.deviceFileStatus === 'ONSD' || scope.row.deviceFileStatus === 'ONUDISK')"
                type="success"
                size="small"
                round
                :disabled="scope.row.deviceVo.online === false"
                @click="uploadToServer(scope.row.fileId),uploadStatus(scope.row,scope.$index)">
                上传服务器
              </el-button>
              <el-button
                v-if="scope.row.deviceFileStatus === 'ONSERVER'"
                class="buttons"
                @click="downloadClick(scope.row.fileId, scope.row.deviceId)"
                type="primary"
                size="small"
                round
              >
                下载至本地
              </el-button>
              <el-button
                class="buttons"
                @click="deleteFile(scope.row.fileId)"
                icon="el-icon-delete"
                type="danger"
                size="small"
                round
                :disabled="(scope.row.deviceFileStatus === 'ONSD' || scope.row.deviceFileStatus === 'ONUDISK')&& scope.row.deviceVo.online === false"
              >删除
              </el-button>
              <el-progress type="line" color="#7ABBE9" style="margin-top:10px" v-show="checkFileId(scope.row.fileId)"
                           :percentage="getPercentage(scope.row.name)"></el-progress>
            </template>
          </el-table-column>
          <el-table-column label="格式转换" width="100">
            <template slot-scope="scope">
              <el-button type="warning" v-show="scope.row.fileType==='asc'&&scope.row.deviceFileStatus === 'ONSERVER'"
                         round size="small"
                         @click="convertBLF(scope.row.deviceVo.deviceId,scope.row.fileId)">转blf格式
              </el-button>
              <!--              <el-button type="success" size="small" disabled round v-else-if="scope.row.fileType === 'blf'">已经是blf-->
              <!--              </el-button>-->
              <!--              <el-button type="warning" round size="small" disabled v-else>不可转换</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import deviceAPI from '@/api/device';
import waiting from '@/components/common/loading/waiting';

export default {
  name: 'file-index-page',
  inject: ['reload'],
  data() {
    return {
      // 多选列表相关
      multipleSelection: [],
      showBatchDownload: false,
      showBatchUpload: false,
      showBatchDelete: false,
      showBatchBlf: false,

      isLoading: true,
      searchVal: '',
      uploadFileToServerVisible: false,
      canUpload: true,

      // 记录用户排序的列及方式
      sortProp: 'creTime',
      sortOrder: 'descending',

      // 记录用户筛选的选择与筛选值对应的键名（用于清空筛选）
      onlineFilter: [],
      onlineFilterKey: '',
      statusFilter: [],
      statusFilterKey: '',
      nameFilter: [],
      nameFilterKey: '',
      deviceFilter: [],
      deviceFilterKey: '',

      fileTimeOptions: {
        shortcuts: [
          {
            text: '1小时内',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - (3600 * 1000 * 1));
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '3小时内',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - (3600 * 1000 * 3));
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '12小时内',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - (3600 * 1000 * 12));
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '24小时内',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - (3600 * 1000 * 24));
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - (3600 * 1000 * 24 * 3));
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - (3600 * 1000 * 24 * 7));
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      timeOption: [],
      curFileList: [],
      currentPage: 1, // 初始页
      pageSize: 10, //    每页的数据
      queryAllFile: [],
      allDeviceList: [], // 所有设备
      curFileListLength: 0,
      timeout: {},

      // 上传进度相关
      percentage: [],
      uploadingList: [],
      isUploading: false,
    };
  },
  mounted() {
    this.getCurFileList();
  },
  computed: {
    filterCondition() {
      return {
        name: this.nameFilter,
        device: this.deviceFilter,
        online: this.onlineFilter,
        status: this.statusFilter,
      };
    },
    sortCondition() {
      return {
        prop: this.sortProp,
        order: this.sortOrder,
      };
    },

  },
  components: { waiting },
  methods: {
    getCurFileList() {
      this.isLoading = true;
      let keyword = this.searchVal;
      if (keyword !== null) {
        keyword = keyword.replace(/^\s+|\s+$/g, '');
      }
      deviceAPI.getCurFileList(this.currentPage, this.pageSize, JSON.stringify(this.timeOption),
        keyword, JSON.stringify(this.filterCondition), JSON.stringify(this.sortCondition)).then((res) => {
        this.curFileList = res;
        this.getDeviceList();
        this.getFileListLength();
        this.isLoading = false;
      });
    },
    getDeviceList() {
      this.allDeviceList = [];
      deviceAPI.getDeviceList().then((res) => {
        res.map((item) => {
          const list = { text: item, value: item };
          this.allDeviceList.push(list);
        });
      });
    },
    getFileListLength() {
      deviceAPI.getFileListLength().then((res) => {
        this.curFileListLength = res;
      });
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getCurFileList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.getCurFileList();
    },
    checkFileListUpdate() {
      deviceAPI.getcurFileList().then((res) => {
        this.curFileList = res;
      }).catch(err => console.log(err));
      this.getCurFileList();
    },
    convertBLF(deviceID, fileID) {
      deviceAPI.changeAscToBlf(deviceID, fileID).then((res) => {
        this.$message(res === undefined ? '转化成功' : '转化异常');
        this.getCurFileList();
      }).catch((err) => {
        this.$message.error(`转化失败, code=${err[0]}, reason=${err[1]}`);
      },
      );
    },
    batchConvertBLF() {
      if (this.multipleSelection.length > 10) {
        this.$message.info(`最多可同时转化10个文件，当前选择${this.multipleSelection.length}个文件`);
        return;
      }
      this.$message.success(`正在转化${this.multipleSelection.length}个文件，请稍候...`);
      this.multipleSelection.map((item) => {
        deviceAPI.changeAscToBlf(item.deviceVo.deviceId, item.fileId)
          .catch((err) => {
            this.$message({
              type: 'error',
              message: `${item.name}转化失败, code=${err[0]}, reason=${err[1]}`,
            });
          });
      });
      setTimeout(() => this.getCurFileList(), 1500);
    },
    downloadClick(fileId) {
      deviceAPI.downloadFileFromServer(fileId);
    },
    batchDownload() {
      if (this.multipleSelection.length > 10) {
        this.$message.info(`最多可同时下载10个文件，当前选择${this.multipleSelection.length}个文件`);
        return;
      }
      this.$message.success(`正在压缩${this.multipleSelection.length}个文件，请稍候...`);
      const idList = [];
      this.multipleSelection.map((item) => {
        idList.push(item.fileId);
      });
      deviceAPI.batchDownloadFileFromServer(idList)
        .then(res => deviceAPI.downloadZipFromServer(res))
        .catch((err) => {
          this.$message({
            type: 'error',
            message: `压缩失败, code=${err[0]}, reason=${err[1]}`,
          });
        });
    },

    deleteFile(id) {
      this.$confirm('此操作将永久删除该文件，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const idVar = [];
        idVar.push(id);
        // 确认删除
        deviceAPI.deleteFile(idVar)
          .then(() => {
            this.$message({
              message: '删除成功！',
            });
            this.getCurFileList();
          })
          .catch((err) => {
            this.$message({
              type: 'error',
              message: `删除失败, code=${err[0]}, reason=${err[1]}`,
            });
          });
      })
        .catch(() => {
          // 取消
          this.$message({
            type: 'info',
            message: '已取消删除操作',
          });
        });
    },
    batchDelete() {
      let success = true;
      this.$confirm(`批量删除${this.multipleSelection.length}个文件，是否继续？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const ids = [];
        this.multipleSelection.map((item) => {
          ids.push(item.fileId);
        });
        deviceAPI.deleteFile(ids)
          .catch((err) => {
            success = false;
            this.$message({
              type: 'error',
              message: `删除失败, code=${err[0]}, reason=${err[1]}`,
            });
          });
        if (success) {
          this.$message.success(`成功删除${this.multipleSelection.length}个文件`);
        }
        setTimeout(() => this.getCurFileList(), 1500);
      }).catch(() => {
        // 取消
        this.$message({
          type: 'info',
          message: '已取消删除操作',
        });
      });
    },

    /**
       * 把文件从设备上上传到服务器上
       * @param fileId 文件id
       */
    uploadToServer(fileId) {
      this.uploadingList.push(fileId);
      deviceAPI.downloadFileToServer(fileId)
        .then(() => {
          this.$message.success('正在上传至服务器，请稍候...');
        })
        .catch((err) => {
          this.$message.error(`不成功, code=${err[0]}, reason=${err[1]}`);
        });
    },
    batchUpload() {
      if (this.multipleSelection.length > 10) {
        this.$message.info(`最多可同时上传10个文件，当前选择${this.multipleSelection.length}个文件`);
        return;
      }
      this.percentage = [];
      this.$message.success(`正在批量上传${this.multipleSelection.length}个文件至服务器，请稍候...`);
      const idList = [];
      this.multipleSelection.map((item) => {
        const index = this.curFileList.findIndex(file => file.name === item.name);
        this.uploadingList.push(item.fileId);
        idList.push(item.fileId);
        this.uploadStatus(item, index);
      });
      deviceAPI.batchDownloadToServer(idList)
        .then(() => {
        })
        .catch((err) => {
          this.$message.error(`不成功, code=${err[0]}, reason=${err[1]}`);
        });
    },

    downloadToDevice(fileId) {
      deviceAPI
        .downloadToDevice(fileId)
        .then(() => {
          this.$message.success('正在等待设备响应，请稍候...');
          // TODO:(Qka, 2019/1/3) 增加对该文件的ws订阅
        })
        .catch((err) => {
          this.$message.error(`不成功, code=${err[0]}, reason=${err[1]}`);
          // TODO:(Qka, 2019/1/3) 取消订阅
        });
    },
    sortChange(obj) {
      this.sortProp = obj.prop;
      this.sortOrder = obj.order;
    },
    filterChange(obj) {
      let key;
      let values;
      for (const i in obj) {
        key = i;
        values = obj[i];
      }
      if (values.length === 0) {
        if (key === this.onlineFilterKey) {
          this.onlineFilter = [];
        } else if (key === this.statusFilterKey) {
          this.statusFilter = [];
        } else if (key === this.nameFilterKey) {
          this.nameFilter = [];
        } else {
          this.deviceFilter = [];
        }
      } else if (values[0] === 'online' || values[0] === 'offline') {
        this.onlineFilterKey = key;
        this.onlineFilter = values;
      } else if (values[0] === 'ONSERVER' || values[0] === 'ONSD' || values[0] === 'ONUDISK') {
        this.statusFilterKey = key;
        this.statusFilter = values;
      } else if (values[0].indexOf('type_') > -1) {
        this.nameFilter = [];
        for (const i in values) {
          this.nameFilterKey = key;
          this.nameFilter.push(values[i].replace('type_', ''));
        }
      } else {
        this.deviceFilter = values;
      }
    },
    handleSelectionChange(val) {
      this.showBatchDelete = false;
      this.showBatchDownload = false;
      this.showBatchUpload = false;
      this.showBatchBlf = false;
      if (this.isUploading) {
        return;
      }
      console.log(val);
      this.multipleSelection = val;
      if (val.length > 0) {
        this.showBatchDownload = true;
        this.showBatchUpload = true;
        this.showBatchBlf = true;
        this.showBatchDelete = true;
        val.map((item) => {
          if (item.deviceFileStatus !== 'ONSERVER') {
            this.showBatchDownload = false;
            this.showBatchBlf = false;
            if (item.deviceVo.online === false) {
              this.showBatchUpload = false;
              this.showBatchDelete = false;
            }
          } else if (item.deviceFileStatus !== 'ONSD' && item.deviceFileStatus !== 'ONUDISK') {
            this.showBatchUpload = false;
          }
          if (item.fileType !== 'asc') {
            this.showBatchBlf = false;
          }
        });
      }
    },
    checkFileId(id) {
      return this.uploadingList.indexOf(id) !== -1;
    },
    //  上传服务器状态显示
    uploadStatus(row, rowIndex) {
      // 打开上传状态显示
      const self = this;
      const name = row.name;
      const id = row.fileId;

      function circle() {
        self.isUploading = true;
        let index = self.percentage.indexOf(name);
        if (!(index > -1)) {
          index = self.percentage.length;
          self.percentage.push(name);
        }
        deviceAPI.getFileProcess(name).then(
          (res) => {
            self.percentage[index + 1] = res[0].per;
            // 接着判断上传状态是否为100
            if (res[0].per === 100) {
              self.$notify({
                title: '文件上传提示',
                message: `${name}上传成功`,
              });
              // 从上传中列表中移除
              self.spliceElement(self.uploadingList, id);
              self.percentage.splice(index, 2);
              self.isUploading = false;
              setTimeout(() => self.getCurFileList(), 1000);
            } else {
              self.$refs.fileTable.toggleRowSelection(self.curFileList[rowIndex]);
              setTimeout(() => circle(), 1000);
            }
          },
        );
      }

      // 第一次先延迟接口请求2秒，再函数内递归请求接口
      setTimeout(circle(), 2000);
    },
    // 获取对应文件名的上传进度
    getPercentage(name) {
      const index = this.percentage.indexOf(name);
      if (index > -1 && (typeof (this.percentage[index + 1])) === 'number') {
        return this.percentage[index + 1];
      }
      return 0;
    },
    spliceElement(arr, element) {
      for (let i = 0; i < arr.length; i += 1) {
        try {
          if (arr[i] === element) {
            arr.splice(i, 1);
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
  },
  watch: {
    searchVal() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.currentPage = 1;
        this.getCurFileList();
      }, 1000);
    },
    filterCondition() {
      this.currentPage = 1;
      this.getCurFileList();
    },
    sortCondition() {
      this.currentPage = 1;
      this.getCurFileList();
    },
    timeOption() {
      this.currentPage = 1;
      this.getCurFileList();
    },
  },
  created() {
    const self = this;
    document.onkeydown = function () {
      const key = window.event.keyCode;
      if (key === 13) {
        // 按Enter键时保持页面序号为2
        self.$store.commit('setPageIndex', 2);
      }
    };
  },
};
</script>

<style lang="scss" scoped>
  @import "../../style/mixin";
  @import "../../style/media";

  .file-index-page {
    height: 100%;
    width: 100%;
    background: rgba(221, 221, 221, 0.17);
    @include focus-scroll-bar;

    .file-whole {
      width: 100%;
      margin-top: 0%;
      padding-top: 0px;
      padding-left: 20px;
      padding-right: 20px;
      @include max_800 {
        width: 800px;
        overflow-x: auto;
      }

      .search {
        height: 200px !important;
        padding-bottom: 20px;

        .search-input {
          width: 100%;
          margin-bottom: 30px;
        }
      }

      .time-page {
        display: flex;
        justify-content: space-between;
        vertical-align: center;
      }

      .file-list {
        margin-top: 20px !important;

        .batch-button {
          margin: 20px 0;
          float: left;
        }

        .el-icon-arrow-left:hover {
          transform: scale(1.8);
        }

        .el-icon-arrow-right:hover {
          transform: scale(1.8);
        }

        .reload-button {
          display: none;
          position: relative;
          float: right;
          margin-top: 10px;
          margin-right: 20px;

          &:hover {
            background: #fff;
            color: #3389e8;
          }
        }

        .show-reload {
          display: block;
        }
      }

      h2 {
        width: 100%;
        height: 60px;
        border-bottom: 1px solid #eee;
        font-size: 16px;
        color: rgb(255, 255, 255);
        text-shadow: 1px 1px 1px #3389e8;
        padding-left: 20px;
        line-height: 50px;
        font-weight: bold;
        background: linear-gradient(
            to top,
            rgba(51, 137, 232, 0.5),
            rgba(51, 137, 232, 0.7)
        );
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/file/index.vue